import { render } from "./Heading.vue?vue&type=template&id=e8ffd04c"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Heading.vue"]])

export default __exports__